import React from 'react';

const LoadingSkeleton = ({ type = 'table', rows = 5 }) => {
    const renderTableSkeleton = () => (
        <div className="skeleton-container">
            <div className="skeleton-header"></div>
            {[...Array(rows)].map((_, i) => (
                <div key={i} className="skeleton-row">
                    <div className="skeleton-cell small"></div>
                    <div className="skeleton-cell medium"></div>
                    <div className="skeleton-cell large"></div>
                    <div className="skeleton-cell small"></div>
                </div>
            ))}
            <style>{`
        .skeleton-container { width: 100%; animation: pulse 1.5s infinite ease-in-out; }
        .skeleton-header { height: 40px; background: #e2e8f0; border-radius: 4px; margin-bottom: 12px; }
        .skeleton-row { display: flex; gap: 12px; margin-bottom: 12px; }
        .skeleton-cell { height: 24px; background: #f1f5f9; border-radius: 4px; }
        .skeleton-cell.small { flex: 1; }
        .skeleton-cell.medium { flex: 2; }
        .skeleton-cell.large { flex: 3; }
        @keyframes pulse {
          0% { opacity: 0.6; }
          50% { opacity: 1; }
          100% { opacity: 0.6; }
        }
      `}</style>
        </div>
    );

    const renderCardSkeleton = () => (
        <div className="skeleton-card" style={{ padding: '24px', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}>
            <div style={{ height: '32px', width: '40%', background: '#e2e8f0', borderRadius: '4px', marginBottom: '16px', animation: 'pulse 1.5s infinite' }}></div>
            <div style={{ height: '16px', width: '90%', background: '#f1f5f9', borderRadius: '4px', marginBottom: '8px', animation: 'pulse 1.5s infinite' }}></div>
            <div style={{ height: '16px', width: '70%', background: '#f1f5f9', borderRadius: '4px', animation: 'pulse 1.5s infinite' }}></div>
            <style>{`
        @keyframes pulse { 0% { opacity: 0.6; } 50% { opacity: 1; } 100% { opacity: 0.6; } }
      `}</style>
        </div>
    );

    return type === 'card' ? renderCardSkeleton() : renderTableSkeleton();
};

export default LoadingSkeleton;
